import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { RadioButton } from "ui";

import { OrderType } from "../../../../constants";
import { FilterFormValues } from "../OrdersFilterForm.types";

import styles from "../OrdersFilterForm.module.scss";

const handleTypeChange = (
  e: React.ChangeEvent<HTMLInputElement>,
  onChange: (value: string | undefined) => void
) => {
  const next = String(e.currentTarget.value);
  onChange(next === "" ? undefined : next);
};

export const OrderTypeBlock = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<FilterFormValues>();

  return (
    <div className={styles.orderFilterForm__block}>
      <h4 className={styles.orderFilterForm__block__title}>
        {t("Order type")}
      </h4>

      <div className={styles.orderFilterForm__block__box}>
        <Controller
          control={control}
          name="type"
          render={({ field: { value, onChange } }) => (
            <>
              <RadioButton
                checked={!value}
                value=""
                onChange={(e) => handleTypeChange(e, onChange)}
                label={t("All")}
              />
              <RadioButton
                checked={value === OrderType.Normal}
                value={OrderType.Normal}
                onChange={(e) => handleTypeChange(e, onChange)}
                label={t("Normal")}
              />
              <RadioButton
                checked={value === OrderType.Expedition}
                value={OrderType.Expedition}
                onChange={(e) => handleTypeChange(e, onChange)}
                label={t("Expedition")}
              />
            </>
          )}
        />
      </div>
    </div>
  );
};
